var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8844 10.3286C18.9617 10.7649 19.0002 11.2069 18.9996 11.6497C18.9996 13.6273 18.2785 15.2993 17.0236 16.4311H17.0253C15.9279 17.4248 14.4194 18 12.6307 18C10.8722 18 9.1856 17.3152 7.9421 16.0963C6.69859 14.8773 6 13.2241 6 11.5002C6 9.77636 6.69859 8.12312 7.9421 6.90417C9.1856 5.68523 10.8722 5.00043 12.6307 5.00043C14.2768 4.98153 15.8664 5.58771 17.0667 6.692L15.1736 8.54769C14.4893 7.90825 13.576 7.55809 12.6307 7.57272C10.9009 7.57272 9.43141 8.71668 8.90758 10.2571C8.62984 11.0643 8.62984 11.9385 8.90758 12.7457H8.91007C9.43638 14.2837 10.9034 15.4277 12.6332 15.4277C13.5267 15.4277 14.2942 15.2035 14.8893 14.807H14.8868C15.2324 14.5826 15.528 14.2919 15.7558 13.9524C15.9836 13.6129 16.1388 13.2318 16.2122 12.8319H12.6307V10.3294L18.8844 10.3286Z",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.cc6926431a86b4bf522d7bf359283d37.svg";
export { ForwardRef as ReactComponent };